import React from 'react';
import InsightsTableRow from '../_shared/InsightsTableRow';

const ActiveUsersRow = ({ number, rowData }) => (
  <InsightsTableRow
    number={number}
    item={rowData.name}
    href={rowData.urls.overview}
    amount={rowData.days_active}
    icon="sign_out"
  />
);

export default ActiveUsersRow;
